/**
 * @fileoverview Define consistent browser labels and guidance for recorded client verification tiers. Matter and Inbox views consume the same vocabulary; backend review evidence determines the accepted tier. Presentation text neither performs verification nor grants banking access.
 */

export const VERIFICATION_LABELS = { none: 'Not verified', stripe: 'Stripe verified', phone: 'Phone verified', video: 'Video verified' };



export function verificationTier(review) {
  if (!['submitted', 'accepted'].includes(review?.status) || review?.submission?.identity?.status !== 'verified') return 'none';
  return review.verification?.tier || 'stripe';
}

 
export function bankingVerificationStatus(review) {
  if (review?.status === 'superseded') return { label: 'Superseded', verified: false };
  if (['awaiting_client', 'awaiting_submission'].includes(review?.status)) return { label: 'Awaiting client', verified: false };
  if (!['submitted', 'accepted'].includes(review?.status)) return { label: 'Not verified', verified: false };
  if (review.banking?.confirmed) return {
    label: review.banking.method === 'stripe' ? 'Verified · Stripe only' : review.banking.method === 'video' ? 'Video verified' : 'Phone verified', verified: true,
  };
  const legacy = verificationTier(review);
  if (!review.banking && ['phone', 'video'].includes(legacy)) return { label: VERIFICATION_LABELS[legacy], verified: true };
  return { label: 'Awaiting staff acceptance', verified: false };
}

 
export const BANKING_REQUEST_CREATED = 'kc-banking-request-created';
